<p-dialog
  [(visible)]="visible"
  header="{{ 'voting.results' | translate }}"
  [style]="{ 'min-width': '40vw', 'max-width': '80vw' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  contentStyleClass="px-6 py-4"
  (onHide)="onClose()">
  <app-voting-result [votingResult]="votingResult"></app-voting-result>

  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button type="button" pButton label="{{ 'common.button.close' | translate }}" (click)="onClose()"></button>
    </div>
  </ng-template>

  <ng-template pTemplate="closeicon">
    <div
      class="p-dialog-header-icon"
      [title]="
        'dialog.button.close'
          | translate
            : {
                '0': 'voting.results' | translate
              }
      ">
      <i class="fa-regular fa-xmark text-lg text-gray-800"></i>
    </div>
  </ng-template>
</p-dialog>
